import { Box, Flex, Stack, Text } from "@chakra-ui/react";
import { useState } from "react";
import { useEffect } from "react";
import FullPageLoader from "../../../components/full-page-loader";
import Heading from "../../../components/Heading";
import GetUserVerifiedSubmitSuccessModal from "../../../components/profile/components/GetUserVerifiedSubmitSuccessModal";
import GetUserVerified from "../../../components/profile/GetUserVerified";
import { ProfileEdit } from "../../../components/profile/ProfileEdit";
import ProfileOverview from "../../../components/profile/ProfileOverview";
import ProfileOverviewUser from "../../../components/profile/ProfileOverviewUser";
import { ProfileSideBar } from "../../../components/profile/ProfileSideBar";
import { getUserProfile } from "../../../context/getUserProfile";
import { useGetState } from "../../../context/useGetState";
import Earning from "../../../components/profile/Earning";
import { ImBackward } from "react-icons/im";

function Profile() {
  const { state, dispatch, loading, firebaseUser } = useGetState();
  const [updatedState, setUpdatedState] = useState({});
  const [refresh, setRefresh] = useState({});
  const [currentTab, setCurrentTab] = useState(0);
  const [showVerificationSumitSuccess, setShowVerificationSumitSuccess] =
    useState(false);

  useEffect(() => {
    getUserProfile(setUpdatedState).then((res) => dispatch({ userInfo: res }));
  }, [refresh]);

  let tabList = {
    1: <ProfileEdit user={state?.userInfo} setRefresh={setRefresh} />,
  };

  return loading ? (
    <FullPageLoader />
  ) : currentTab === 0 ? (
    <ProfileOverview
      editable={true}
      setCurrentTab={setCurrentTab}
      setRefresh={setRefresh}
    />
  ) : currentTab === 2 ? (
    <Stack>

      <Flex alignItems="center">
        <Heading textAlign="left" onClick={() => setCurrentTab(1)} cursor={"pointer"}><ImBackward /></Heading>
        <Flex flex="1" justifyContent="center">
          <Heading textAlign="center">User Verification</Heading>
        </Flex>
      </Flex>
      
      <Stack
        display={"none"}
        onClick={() => setCurrentTab(1)}
        cursor={"pointer"}
        direction={"row"}
        alignItems="center"
        color="#fff"
        bg="#00157E"
        borderRadius={"5px"}
        p="2px 20px 2px 10px"
      >
        <ImBackward fontSize={"1.7em"} />
        <Text fontSize={".9em"}>Back to Profile Settings</Text>
      </Stack>

      <Stack alignItems={"center"}>
        <GetUserVerified
          setShowVerificationSumitSuccess={setShowVerificationSumitSuccess}
        />
        <GetUserVerifiedSubmitSuccessModal
          setShowVerificationSumitSuccess={setShowVerificationSumitSuccess}
          showVerificationSumitSuccess={showVerificationSumitSuccess}
        />
      </Stack>
    </Stack>
  ) : currentTab === 3 ? (
    <>
      <Flex gap={"5"} alignItems={"center"}>
        <Heading onClick={() => setCurrentTab(1)} cursor={"pointer"}><ImBackward /></Heading>
        <Heading>Earnings</Heading>
      </Flex>
        
        <Earning/>
    </>
    
  ) : (
    <Box pr="40px" ml={["0px", "0px", "0px", "20px"]}>
      <Heading textAlign={"left"} mb="20px" fontSize="2.2em">
        Profile
      </Heading>
      <Stack
        width="100%"
        direction={"row"}
        alignItems="flex-start"
        justifyContent="space-around"
      >
        <Box flex="1">
          <ProfileSideBar setCurrentTab={setCurrentTab} />
        </Box>
        <Box flex="7">{tabList[currentTab]}</Box>
      </Stack>
    </Box>
  );
}

export default Profile;
